import { Typography } from '@mui/material';
import { Stack, useTheme } from '@mui/system';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import { screamingPeerCategoryToTitle } from '../../functions/dataFormatting';

/**
 * Renders a list of attributes relating to the peer group of a selected portfolio
 * (Geo Category, Style, Market Cap Focus, number of portfolios in peer group).
 *
 * Renders either as a horizontal or vertical list.
 *
 * @component
 * @param selectedPortfolio - Currently selected portfolio
 * @param peerCount - Number of portfolios in selected portfolio's peer group
 * @param isHorizontal - Whether to render list horizontally or vertically
 * @returns {React.ReactElement} The rendered PeerGroupDetails component
 */
const PeerGroupDetails = ({
    selectedPortfolio,
    peerCount,
    isHorizontal = false
}) => {
    const theme = useTheme();

    const peer_group_data = [
        { id: 'Geography', value: selectedPortfolio?.geoCategory },
        { id: 'Style', value: selectedPortfolio?.style },
        { id: 'Market Cap', value: selectedPortfolio?.marketCapFocus },
        { id: 'Peer Count', value: peerCount }
    ];

    return (
        <Stack
            width='100%'
            justifyContent='space-around'
            spacing={{ md: 1 }}
            direction={isHorizontal ? 'row' : 'column'}
            data-analyticsid='peer-group'
        >
            {peer_group_data.map((item) => (
                <Box key={item.id}>
                    <Typography fontSize={12} color={theme.palette.font.light}>
                        {item.id}
                    </Typography>
                    <Typography
                        variant='body1'
                        fontWeight={500}
                        sx={{ paddingBottom: !item.value && 3 }}
                    >
                        {item.id === 'Peer Count'
                            ? item.value
                            : screamingPeerCategoryToTitle(item.value)}
                    </Typography>
                </Box>
            ))}
        </Stack>
    );
};

PeerGroupDetails.propTypes = {
    selectedPortfolio: PropTypes.object,
    peerCount: PropTypes.number,
    isHorizontal: PropTypes.bool
};

export default PeerGroupDetails;
